import React from 'react';
import PropTypes from 'prop-types';
import BaseTable from './shared/BaseTable';
import { cellOperation, headerOperation } from '../helpers/tables';

const CreditPolicyDetailFiliales = ({filiales}) => {
  const columns = [
    {
      Header: headerOperation('RUT'),
      id: 'rut',
      accessor: i => cellOperation(i.cliente.rut),
      minWidth: 100,
      sortable: false,
    },
    {
      Header: headerOperation('Nombre'),
      id: 'nombre',
      accessor: i => cellOperation(i.cliente.nombre),
      minWidth: 200,
      sortable: false,
    },
    {
      Header: headerOperation('Facturación'),
      id: 'facturacion',
      accessor: i => cellOperation(i.facturacion ? 'Si' : 'No'),
      minWidth: 100,
      sortable: false,
    }
  ];

  return (
    <BaseTable columns={columns} data={filiales} />
  );
};

CreditPolicyDetailFiliales.propTypes = {
  filiales: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })).isRequired,
};

export default CreditPolicyDetailFiliales;
